import { useEffect, useState } from "react";
import SideBar from "../components/sideBar";
import { fetchHomeApi, homeData } from "../signals/homeData.signal";
import translateText, {
  currentLanguage,
  LanguageDirection,
} from "../signals/language.signal";
import {
  primary,
  primaryFount,
  secondary,
} from "../signals/Theme colors.signal";
import { logClientName } from "../signals/login.signal";
import Slideshow from "../components/Slideshow";
import ReactApexChart from "react-apexcharts";
import { getCurrencySymbol } from "../components/CurrencySymbol";

const HomePage = () => {
  const [active, setActive] = useState(1);

  const currentDate = new Date();
  const dayName = translateText(currentLanguage.value, "daysOfWeek")[
    currentDate.getDay()
  ];
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();
  const Hours = currentDate.getHours();

  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;
  const isActive = (isactive) => {
    return isactive === active
      ? { background: primary.value, color: primaryFount.value }
      : {};
  };
  useEffect(() => {
    homeData.value = "";
    const fetchData = async () => {
      try {
        const result = await fetchHomeApi();
        homeData.value = result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [state, setState] = useState({
    series: [0],
    options: {
      chart: {
        height: 450,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "60%", // حجم التجويف الداخلي
          },
          track: {
            margin: 5, // المسافة بين الخلفية والدائرة
          },
          dataLabels: {
            show: true,
            name: {
              show: false, // إخفاء النص فوق الرقم
            },
            value: {
              fontSize: "28px", // حجم الرقم داخل الدائرة
              fontWeight: 60,
              show: true,
            },
          },
        },
      },
      labels: [""],
      colors: [primary.value],
    },
  });

  return (
    <div
      id="homePage"
      className=" align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "HomeTitle")}
      />
      <div className=" loginContaner  align-items-sm-center align-items-center d-flex  justify-content-center w-100 p-3 mt-3">
        <div className="w-100">
          <p style={{ fontSize: "20px" }} className="m-0">
            {Hours > 6 && Hours < 12
              ? translateText(currentLanguage.value, "Morning")
              : translateText(currentLanguage.value, "Hello")}
          </p>
          <p
            className="m-0"
            style={{
              color: primary.value,
              fontSize: "20px",
              fontWeight: "700",
            }}
          >
            {logClientName.value}
          </p>
        </div>
        <div className="rounded-3 shadow ">
          <p
            style={{
              background: primary.value,
              fontSize: "10px",
              textAlign: "center",
              color: "#fff",
            }}
            className="m-1 rounded-3 pe-2 ps-2"
          >
            {dayName}
          </p>
          <p
            className="m-1"
            style={{
              color: primary.value,
              fontSize: "10px",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
            {formattedDate}
          </p>
        </div>
      </div>
      <div className="loginContaner align-items-sm-center align-items-center d-flex  justify-content-center w-100  gap-2">
        <Slideshow />
      </div>
      <div className="loginContaner align-items-sm-center align-items-center d-flex  justify-content-center w-100 p-3 mt-3 gap-2">
        <p
          className="d-flex m-0 ps-2 pe-2 border border-1 justify-content-center align-items-center rounded-3 w-50"
          style={{
            ...isActive(1),
            fontSize: "12px",
            padding: "4px",
            width: "65px",
          }}
          onClick={() => {
            setActive(1);
          }}
        >
          {translateText(currentLanguage.value, "Current Month")}
        </p>
        <p
          className="d-flex m-0 ps-2 pe-2 border border-1 justify-content-center align-items-center rounded-3 w-50"
          style={{
            ...isActive(2),
            fontSize: "12px",
            padding: "4px",
            width: "65px",
          }}
          onClick={() => {
            setActive(2);
          }}
        >
          {translateText(currentLanguage.value, "Current Year")}
        </p>
      </div>

      <div className="loginContaner  d-flex align-items-sm-center align-items-center d-flex  justify-content-center w-100 p-3">
        <div
          style={{
            background: secondary.value,
          }}
          className="loginContainer  p-md-5 w-100 shadow rounded-3 d-flex align-items-center"
        >
          <div style={{ width: "50%" }}>
            <div id="chart">
              <ReactApexChart
                options={state.options}
                series={
                  homeData.value
                    ? [
                        Math.round(
                          active === 2
                            ? Number(homeData.value.Y_RATE)
                            : Number(homeData.value.RATE)
                        ),
                      ]
                    : [0]
                }
                type="radialBar"
                height={450}
              />
            </div>
            <div id="html-dist"></div>
          </div>
          <div
            className={
              LanguageDirection.value === "rtl" ? "text-end" : "text-start"
            }
            style={{ width: "50%" }}
            dir="ltr"
          >
            <p style={{ fontSize: "24px" }} className="m-0">
              {translateText(currentLanguage.value, "Goles")}
            </p>
            <p
              style={{
                color: primary.value,
                fontSize: "24px",
                fontWeight: "700",
                margin: "0px",
              }}
            >
              {getCurrencySymbol(primary.value)}
              {homeData.value
                ? active == 2
                  ? Number(homeData.value.YEAR_TARGET).toLocaleString()
                  : Number(homeData.value.MONTH_TARGET).toLocaleString()
                : "0"}
            </p>
          </div>
        </div>
      </div>

      {homeData.value ? (
        <>
          <>
            <div className="loginContaner  align-items-sm-center align-items-center d-flex  justify-content-center w-100 p-3 mt-3">
              <div
                style={{
                  background: primary.value,
                  color: primaryFount.value,
                }}
                className="loginContainer p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
              >
                <p style={{ fontSize: "14px" }}>
                  {translateText(currentLanguage.value, "intarget")}
                </p>
                <h1 dir="ltr">
                  {getCurrencySymbol("#ffffff")}
                  {active == 2
                    ? Number(homeData.value.Y_NET_SALES).toLocaleString()
                    : Number(homeData.value.NET_SALES).toLocaleString()}
                </h1>
              </div>
            </div>
            <div className="loginContaner  align-items-sm-center align-items-center d-flex  justify-content-center w-100 p-3 mt-3">
              <div
                style={{
                  background: primary.value,
                  color: primaryFount.value,
                }}
                className="loginContainer p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
              >
                <p style={{ fontSize: "14px" }}>
                  {translateText(currentLanguage.value, "outtargit")}
                </p>
                <h1 dir="ltr">
                  {getCurrencySymbol("#ffffff")}
                  {active == 2
                    ? Number(
                        homeData.value.Y_TOTAL_SALES_WITH_DISC
                      ).toLocaleString()
                    : Number(
                        homeData.value.TOTAL_SALES_WITH_DISC
                      ).toLocaleString()}
                </h1>
              </div>
            </div>
            {homeData.value.Y_TOTAL_SALES_LATE_DUE > 0 &&
            homeData.value.TOTAL_SALES_LATE_DUE > 0 ? (
              <div className="loginContaner  align-items-sm-center align-items-center d-flex  justify-content-center w-100 p-3 mt-3">
                <div
                  style={{
                    background: primary.value,
                    color: primaryFount.value,
                  }}
                  className="loginContainer p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
                >
                  <p style={{ fontSize: "14px" }}>
                    {translateText(currentLanguage.value, "latePay")}
                  </p>
                  <h1 dir="ltr">
                    {getCurrencySymbol("#FFF")}
                    {active == 2
                      ? Number(
                          homeData.value.Y_TOTAL_SALES_LATE_DUE
                        ).toLocaleString()
                      : Number(
                          homeData.value.TOTAL_SALES_LATE_DUE
                        ).toLocaleString()}
                  </h1>
                </div>
              </div>
            ) : (
              <></>
            )}
          </>

          <div className="loginContaner  d-flex w-100 flex-wrap">
            <div className="p-3 w-50 col-6  ">
              <div
                style={{ background: primary.value, color: primaryFount.value }}
                className="loginContaner p-3  flex-column  shadow rounded-3 d-flex justify-content-center align-items-center h-100"
              >
                <p style={{ fontSize: "14px" }}>
                  {translateText(currentLanguage.value, "Invoices")}
                </p>
                <h1>
                  {active == 2
                    ? homeData.value.Y_INV_NUM
                    : homeData.value.INV_NUM}
                </h1>
              </div>
            </div>
            <div className="p-3 w-50 col-6">
              <div
                style={{ background: primary.value, color: primaryFount.value }}
                className="loginContaner p-3  flex-column  shadow rounded-3 d-flex justify-content-center align-items-center h-100"
              >
                <p style={{ fontSize: "14px" }}>
                  {translateText(currentLanguage.value, "LATEPRO")}
                </p>
                <h1>
                  {active == 2
                    ? homeData.value.Y_COUNT_LATE_PRO
                    : homeData.value.COUNT_LATE_PRO}
                </h1>
              </div>
            </div>
            <div className="p-3 w-50 col-6">
              <div
                style={{ background: primary.value, color: primaryFount.value }}
                className="loginContaner p-3  flex-column  shadow rounded-3 d-flex justify-content-center align-items-center h-100"
              >
                <p style={{ fontSize: "14px" }}>
                  {translateText(currentLanguage.value, "Returns")}
                </p>
                <h1>
                  {active == 2
                    ? homeData.value.Y_BAK_NUM
                    : homeData.value.BAK_NUM}
                </h1>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="loginContaner align-items-sm-center d-flex justify-content-center w-100 p-3">
            <div
              style={{ background: primary.value, color: primaryFount.value }}
              className="loginContainer p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
            >
              <p style={{ fontSize: "14px" }}>
                {translateText(currentLanguage.value, "intarget")}
              </p>
              <h1 dir="ltr">{getCurrencySymbol("#FFF")}0 </h1>
            </div>
          </div>
          <div className="align-items-sm-center d-flex justify-content-center w-100 p-3">
            <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
              <div
                style={{ height: "112.88px" }}
                className=" skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
              ></div>
            </div>
          </div>
          <div className="align-items-sm-center d-flex justify-content-center w-100 p-3">
            <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
              <div
                style={{ height: "112.88px" }}
                className=" skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
              ></div>
            </div>
          </div>
          <div className="align-items-sm-center d-flex justify-content-center w-100 p-3">
            <div className="align-items-sm-center loginContaner d-flex justify-content-center w-100">
              <div
                style={{ height: "112.88px" }}
                className=" skeleton p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center"
              ></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default HomePage;
